export function checkLive(endpoint, self) {
    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=check_" + endpoint + "_live",
        datatype: "json",
        data: {
            "value": self.val(),
        },
        success: function (output) {
            var val = JSON.parse(output).value;
            if (val) {
                self.removeClass("text_error");
                self.removeClass("text");
                self.addClass("text_success");
            } else {
                self.removeClass("text");
                self.removeClass("text_success");
                self.addClass("text_error");
                if (endpoint == "nickname_slug") {
                    self.tooltip("enable");
                    self.tooltip("show");
                } else {
                    self.parent().tooltip("enable");
                    self.parent().tooltip("show");
                }
            }
        }
    });
}
